import { AnalyticsCommonDeviceInfo } from './common.model';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface AddDevicesDialogLaunchedEvent {}

export interface AddDevicesDialogCancelledEvent {
	step: 'step_1' | 'step_2';
}

interface AddDevicesByMacSerialEvent {
	method: AddDeviceMethod.MacSerialIndividual | AddDeviceMethod.MacSerialCsvFile | AddDeviceMethod.QrCode;
	devices: Pick<AnalyticsCommonDeviceInfo, 'mac' | 'serial'>[];
}

interface AddDevicesByLocalNetworkScanningEvent {
	method: AddDeviceMethod.LocalNetworkScanning;
	devices: AnalyticsCommonDeviceInfo[];
}

export type AddDevicesDialogDevicesAddedEvent = AddDevicesByMacSerialEvent | AddDevicesByLocalNetworkScanningEvent;

export enum AddDeviceMethod {
	MacSerialIndividual = 'mac_serial_individual',
	MacSerialCsvFile = 'mac_serial_csv_file',
	QrCode = 'qr_code',
	LocalNetworkScanning = 'local_network_scanning'
}
